export default __webpack_public_path__ + "static/media/nonambulant.34dc1be4.svg";